// Styled Components
import styled from "styled-components";

// Components
import IntroMint from "./IntroMint/IntroMint";

const Intro = (props) => {
  return (
    <Wrapper>
      <h1 className="header">
        SHOEUZI NFT
        <div className="spacer"></div>
        SEASON 1
      </h1>
      <p className="public-sale">PUBLIC SALE: 6TH DECEMBER @ 19:00 UTC</p>
      <IntroMint
        candyMachineId={props.candyMachineId}
        config={props.config}
        connection={props.connection}
        startDate={props.startDate}
        treasury={props.treasury}
        txTimeout={props.txTimeout}
      />
    </Wrapper>
  );
};

export default Intro;

const Wrapper = styled.div`
  width: 100%;
  height: max-content;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  //
  padding: 0 20px;
  padding-top: 100px;
  @media only screen and (max-width: 900px) {
    padding: 0 15px;
    padding-top: 75px;
  }
  //

  .header {
    font-family: "Pixeltype";
    font-weight: 200;
    line-height: 130px;

    // font-style: normal;
    //  line-height: 100px;

    text-align: center;

    //
    font-size: 7rem;
    @media only screen and (max-width: 1250px) {
      font-size: 6rem;
      line-height: 110px;
    }

    @media only screen and (max-width: 900px) {
      font-size: 4rem;
      line-height: 90px;
    }
    @media only screen and (max-width: 550px) {
      font-size: 3rem;
      line-height: 60px;
    }
    //
  }

  .public-sale {
    font-family: "Pixeltype";
    font-weight: 200;

    font-style: normal;
    text-align: center;

    font-size: 1.4rem;
    padding-top: 40px;

    line-height: 30px;
  }
`;
